import {
  getCreateProject,
  postSaveProject,
  impostascambiatoreselezionato,
  postCalculate,
  postCheckWarningSeContinuarePreCalcolo,
  getOpenProject,
  postSetDefaults,
  getDefaults,
  postUpdateProject
} from "./services";
import * as types from "./types";

export async function checkWarningSeContinuarePreCalcolo({ commit }, payload) {
  try {
    return (await postCheckWarningSeContinuarePreCalcolo(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function calculate({ commit }, payload) {
  try {
    return (await postCalculate(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function open({ commit }, payload) {
  try {
    return (await getOpenProject(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function create({ commit }, payload) {
  try {
    return (await getCreateProject(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function save({ commit }, payload) {
  try {
    return (await postSaveProject(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function update({ commit }, payload) {
  try {
    return (await postUpdateProject(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function changeProperty({ commit }, payload) {
  try {
    commit(types.CHANGE_PROPERTY, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function setTypePiastra({ commit }, payload) {
  try {
    commit(types.SET_TYPE_PIASTRA, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function setVerifica({ commit }, payload) {
  try {
    commit(types.SET_VERIFICA, payload);
    commit(types.SET_SELEZIONE, !payload);
  } catch (e) {
    console.log(e);
  }
}

export async function setSelezione({ commit }, payload) {
  try {
    commit(types.SET_VERIFICA, !payload);
    commit(types.SET_SELEZIONE, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function clear({ commit }) {
  try {
    commit(types.CLEAR);
  } catch (e) {
    console.log(e);
  }
}

export async function load({ commit }, payload) {
  try {
    commit(types.LOAD, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function remove({ commit }, payload) {
  try {
    commit(types.REMOVE, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function updatePrjOnStore({ commit }, payload) {
  try {
    commit(types.UPDATE, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function setResults({ commit }, payload) {
  try {
    commit(types.SET_RESULTS, payload);
  } catch (e) {
    console.log(e);
  }
}

export async function impostaScambSelezionato({ commit }, payload) {
  try {
    return (await impostascambiatoreselezionato(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function setSelectionResults({ commit }, payload) {
  try {
    commit(types.SET_SELECTION_RESULTS, payload);
  } catch (e) {
    console.log(e);
  }
}
export async function setDefaults({ commit }, payload) {
  try {
    return await postSetDefaults(payload);
  } catch (e) {
    console.log(e);
  }
}
export async function defaults({ commit }) {
  try {
    return (await getDefaults()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function saveDefValuesInStore({ commit }, payload) {
  try {
    commit(types.SET_DEFAULT_VALUES, payload);
  } catch (e) {
    console.log(e);
  }
}
export async function setBloccoCalcolo({ commit }, payload) {
  try {
    commit(types.SET_BLOCCO_CALCOLO, payload);
  } catch (e) {
    console.log(e);
  }
}
